import jsPDF from "jspdf";
import "jspdf-autotable";
import GemarBg from "../../../images/Gemar-USA-Logo-RGB-POS.png";

const transactionReportPDF = (
  tableRows,
  columns,
  isLandscape,
  title,
  productDetails,
  columnStyles
) => {
  const doc = new jsPDF({
    orientation: isLandscape ? "landscape" : "portrait",
  });

  const left = 14;
  const top = 5;
  const imgWidth = 50;
  const imgHeight = 15;
  const pageWidth = doc.internal.pageSize.getWidth();
  const sectionWidth = (pageWidth - left * 2 - imgWidth - 10) / 4; // Divide remaining space into 4 equal parts
  const subHeaderleft = 14;

  const header = (data) => {
    doc.addImage(GemarBg, "PNG", left, top, imgWidth, imgHeight);
    doc.setFontSize(10);
    doc.setTextColor(128, 128, 128);
    doc.text(left + imgWidth + 10, 10, title);
    doc.text(
      left + imgWidth + 10,
      14,
      "Gemar USA – Distributor Phone: +1 (786) 7622949."
    );
    doc.setLineWidth(0.5);

    // Add product details text elements with equal width and wrapping
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0);
  };

  let productTop = 26; // Top position for the product details text
  var labelStartingPosition = 14;

  const drawText = (label, value, index, mid) => {
    const startX = subHeaderleft + index * sectionWidth;
    const textWidth = sectionWidth - 25; // Adjust width for text wrapping
    const wrappedText = doc.splitTextToSize(value);

    doc.setFontSize(12);
    doc.text(startX, productTop, `${label} :`);
    doc.setFontSize(12);

    labelStartingPosition = startX + textWidth + mid;
    doc.text(labelStartingPosition, productTop, wrappedText);
  };
  if (productDetails?.TransactionType) {
    drawText("From Date", productDetails?.FromDate, 0, 17);
    drawText("To Date", productDetails?.ToDate, 3, 14);
    productTop = productTop + 7;
    drawText("Transaction Type", productDetails?.TransactionType, 0, 32);
    // drawText("Transaction Type", productDetails?.TransactionType, 4,32);
  } else {
    drawText("Product SKU", productDetails?.SKU, 0, 1);
    drawText("Product Name", productDetails?.ProductName, 2, 3);
    drawText("Stock Quantity", productDetails?.StockQuantity, 4, 3);
    productTop = productTop + 7;
    drawText("Product Location", productDetails?.Location, 0, 8);
  }

  doc.autoTable({
    theme: "grid",
    columns: columns,
    body: tableRows,
    columnStyles: columnStyles,
    // columnStyles: columns.reduce((styles, col, i) => {
    //   styles[i] = { halign: "center" }; // Align text to center for each column
    //   return styles;
    // }, {}),
    didDrawPage: (data) => header(data),
    margin: {
      top: 30, // Adjusted to accommodate product details text element
    },
    startY: 45,
    headStyles: {
      fillColor: "#00a3da",
      fontSize: 12,
      halign: "center",
    },
    styles: {
      valign: "middle",
    },
  });

  doc.save(`${title}.pdf`);
};

export default transactionReportPDF;
